import type { ReactNode } from "react";
import { AlertTriangle, Database, LoaderCircle, RefreshCw } from "lucide-react";
import type { RemoteState } from "../lib/useRemote";

export function RemotePanel<T>({ state, onRetry, children, empty }: {
  state: RemoteState<T>; onRetry: () => void; children: (data: T) => ReactNode; empty?: ReactNode;
}) {
  if (state.status === "loading") return <div className="remote-state"><LoaderCircle className="spin" /><strong>正在读取控制面数据</strong><span>请求真实服务状态，请稍候。</span></div>;
  if (state.status === "error") return <div className="remote-state error"><AlertTriangle /><strong>数据读取失败</strong><span>{state.message}</span><button className="button secondary" onClick={onRetry}><RefreshCw size={16} />重试</button></div>;
  if (state.status === "empty") return <div className="remote-state"><Database /><strong>暂无记录</strong><span>{empty ?? "当前查询没有返回记录。"}</span>{children(state.data)}</div>;
  return <>{children(state.data)}</>;
}
